<template>
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M.5 8a7.5 7.5 0 111.91 5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
